






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {RelatorioGeracao} from '@/model/resource/RelatorioGeracao'
import {InputRelatorioGeracaoSchema} from '@/schema/resource/RelatorioGeracao/InputRelatorioGeracaoSchema'

@Component
export default class PersistRelatorioGeracaoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputRelatorioGeracaoSchema()
  relatorioGeracao = new RelatorioGeracao()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
    this.schema.collectionTipoRelatorio.listTipoRelatorio()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.relatorioGeracao.getRelatorioGeracao(id)
    }

    $.await.done('getRelatorioGeracao')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.relatorioGeracao.persistRelatorioGeracao()
    await Helper.successAndPush(
      'system.success.persist',
      '/relatorio-geracao/list'
    )
  }
}
